import 'react-responsive-carousel/lib/styles/carousel.min.css';
import * as Styles from './styles';
import {useTheme} from '../../contexts/Theme';
import BannerItems from '../BannerItems/BannerItems';
import {RoundedIconButton} from '../Buttons/IconButton';
import {IconExpandLess,ICON_SIZE,BUTTON_SIZES} from 'cdk-radial';

export default function Banner(props: { closetColor: Function, hideBanner: Function, bannerData: any }) {
    const {darkMode} = useTheme();

    return (
        <><Styles.BannerWrapper>
                <Styles.CarouselContainer data-testid="banner">
                    <Styles.CarouselCloseContainer>
                        <RoundedIconButton
                            darkMode={darkMode}
                            data-testid="closeIcon"
                            icon={<IconExpandLess/>}
                            onClick={props.hideBanner}
                            size={BUTTON_SIZES.SMALL}
                            iconSize={ICON_SIZE.SMALL}
                            text=''
                        />
                    </Styles.CarouselCloseContainer>
                    {!!props?.bannerData?.length && <BannerItems closetColor={props.closetColor} bannerItems={props.bannerData}/>}
                </Styles.CarouselContainer>
            </Styles.BannerWrapper>
        </>
    );
}
